import { Table, Typography, Badge } from "antd"
import React from "react"
import { OrderAndPrefix } from "../../Orders/Helpers/OrderAndPrefix"
import { generateFilter } from "../../Orders/JobFilters"
import { useCollection } from "../../../hooks/useCollection"
import { returnProperMachineTag } from "../../utils/ReturnProperMachineTag"
import { OrderLocation } from "../../Orders/OrderLocation"
import moment from "moment/moment"
import FinishCutterOrder from "./FinishCutterOrder"

const { Text } = Typography

export default function ActiveOrders({ activeKey }) {
  const { loading, data } = useCollection("orders", ["orderStatus", "==", 4.5])

  //filters
  let clientFilters = generateFilter(data, ["client", "client"])
  let productFilter = generateFilter(data, ["selectedProduct", "product", "productName"])
  let materialFilter = generateFilter(data, ["selectedProduct", "material"])
  let machineFilter = generateFilter(data, ["selectedProduct", "machine"])

  //default columns for table
  const defaultColumns = [
    {
      title: "Nr.",
      dataIndex: "orderNumber",
      align: "center",
      sorter: (a, b) => a.orderNumber - b.orderNumber,
      render: (value, record) => OrderAndPrefix(record),
    },
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
      filters: clientFilters,
      onFilter: (value, record) => record.client.client.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
      filters: productFilter,
      onFilter: (value, record) => record.selectedProduct.product.productName.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Manager",
      dataIndex: "user",
      align: "center",
    },
    {
      title: "Manufacturer",
      dataIndex: ["manufacturer", "company"],
      align: "center",
    },
    {
      title: "Machine",
      dataIndex: ["selectedProduct", "machine"],
      align: "center",
      filters: machineFilter,
      onFilter: (value, record) => record.selectedProduct.machine.startsWith(value),
      filterSearch: true,
      render: (value) => {
        return returnProperMachineTag(value)
      },
    },

    {
      title: "Material",
      dataIndex: ["selectedProduct", "material"],
      align: "center",
      filters: materialFilter,
      onFilter: (value, record) => record.selectedProduct.material.startsWith(value),
      filterSearch: true,
    },
    {
      title: "Location",
      dataIndex: "orderStatus",
      align: "center",
      render: (value) => <Badge status="processing" text={OrderLocation(value)} />,
    },
    {
      title: "Created",
      dataIndex: "created",
      align: "center",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.created.seconds - b.created.seconds,
      render: (value) => (
        <>
          <Text>{value && moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },

    {
      title: "Action",
      align: "center",
      render: (value, record) => (
        <>
          <FinishCutterOrder order={record} />
        </>
      ),
    },
  ]

  return (
    <div>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={loading}
        columns={defaultColumns}
        dataSource={data}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
      />
    </div>
  )
}
